export default __webpack_public_path__ + "logo-aptaclub.1a57b0f.png";